var _a;
import { DOMMutationType } from 'pathfinder/modules/shared/useMutationObserver';
import log from 'pathfinder/utils/log';
import { getHTMLElementVisibility } from 'pathfinder/utils/getHTMLElementProperties';
export const wrapperSelector = 'pathfinder-wrapper';
export const topMobileSearchSelector = 'global-navigation-mobile-search__content wds-search-is-active';
export const moduleTopMutationObsTarget = (_a = document === null || document === void 0 ? void 0 : document.body) !== null && _a !== void 0 ? _a : null;
export const moduleTopMutationObsOptions = { childList: true, subtree: false };
const mobileSearchContainerSelector = 'global-navigation-mobile-search wds-global-navigation__modal wds-search-modal';
// calculate top position
export default function getModuleTop() {
    return getNavHeight() + getBannerHeight() + getSearchBarHeight();
}
function getBannerHeight() {
    var _a, _b, _c;
    // @ts-expect-error We have `offsetHeight` on that item
    return (_c = (_b = (_a = document.getElementsByClassName('wds-banner-notification__container')) === null || _a === void 0 ? void 0 : _a.item(0)) === null || _b === void 0 ? void 0 : _b.offsetHeight) !== null && _c !== void 0 ? _c : 0;
}
function getNavHeight() {
    var _a, _b;
    // @ts-expect-error We have `offsetHeight` on that item
    return (_b = (_a = document.querySelector('.mobile-global-navigation__wrapper')) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0;
}
function getSearchBarHeight() {
    var _a, _b, _c;
    // @ts-expect-error We have `offsetHeight` on that item
    return (_c = (_b = (_a = document.getElementsByClassName(topMobileSearchSelector)) === null || _a === void 0 ? void 0 : _a.item(0)) === null || _b === void 0 ? void 0 : _b.offsetHeight) !== null && _c !== void 0 ? _c : 0;
}
export const handleMobileSearchStateChanges = (mutations) => {
    var _a;
    const wrapperElement = (_a = document.getElementsByClassName(wrapperSelector)) === null || _a === void 0 ? void 0 : _a.item(0);
    if (getHTMLElementVisibility(wrapperElement)) {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                updateTopOffset(node, DOMMutationType.ADD, wrapperElement);
            });
            mutation.removedNodes.forEach((node) => {
                updateTopOffset(node, DOMMutationType.REMOVE, wrapperElement);
            });
        });
    }
};
/** Returns true whenever the top property was updated on the passed in Node */
const updateTopOffset = (node, DOMActionType, wrapperElement) => {
    var _a;
    const mutatedHTMLNode = node;
    if (((_a = mutatedHTMLNode === null || mutatedHTMLNode === void 0 ? void 0 : mutatedHTMLNode.className) === null || _a === void 0 ? void 0 : _a.includes(mobileSearchContainerSelector)) && wrapperElement) {
        let newTopOffset;
        if (DOMActionType === DOMMutationType.ADD) {
            newTopOffset = `${getModuleTop()}px`;
        }
        else if (DOMActionType === DOMMutationType.REMOVE) {
            newTopOffset = '';
        }
        else {
            log.debug("No valid DOMActionType was specified. Top offset won't be updated on DOM Mutation");
        }
        log.debug(`${DOMActionType} element found with mobileSearchContainerSelector. New calculated top value will be: `, newTopOffset);
        wrapperElement.style['top'] = newTopOffset;
    }
};
